module.exports = __webpack_public_path__ + "static/media/Teaching.4860199a.txt";